import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

switch(localStorage.getItem("lang")){
        case  "en":

          var home_page   = "home page";
          var software_product = "software product";
          var Intelligent_town_management_system = "Intelligent town management system";
          var Big_data_management_system = "Big data management system";
          var Related_service = "Related service";
          var News_trends = "News trends";
          var Company_introduction = "Company introduction";
          var Job_opportunity = "Job opportunity";
          var Contact_us = "Contact us";
          var hours_at_your_service = "hours at your service";
        break;
        case  "ru":

           var home_page   = "Главная страница";
           var software_product = "Программные продукты";
           var Intelligent_town_management_system = "Умная городская система управления";
           var Big_data_management_system = "Большая система управления данными";
           var Related_service = "Соответствующие услуги";
           var News_trends = "Динамика новостей";
           var Company_introduction = "Представление компании.";
           var Job_opportunity = "Предложение работы.";
           var Contact_us = "Свяжись с нами.";
           var hours_at_your_service = "серия к вашим услугам";
        break;
        default:

          var home_page   = "深圳市中望信息科技有限公司";
          var software_product = "软件产品";
          var Intelligent_town_management_system = "智能小镇管理系统";
          var Big_data_management_system = "大数据管理系统";
          var Related_service = "相关服务";
          var News_trends = "新闻动态";
          var Company_introduction = "公司介绍";
          var Job_opportunity = "工作机会";
          var Contact_us = "联系我们";
          var hours_at_your_service = "小时为您服务";
        break;
      }


export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: home_page
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: software_product
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: software_product+'丨'+Intelligent_town_management_system
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: software_product+'丨'+Big_data_management_system
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: Related_service
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: News_trends
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: Company_introduction
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: Job_opportunity
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: Contact_us
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: Related_service
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js